import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=3277d640&"
import script from "./InvoicePreview.vue?vue&type=script&lang=js&"
export * from "./InvoicePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports